import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormRecord, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {BirthdateDividedComponent} from '../../ux/birthdate-divided/birthdate-divided.component';
import {Country, MatSelectCountryModule} from '@angular-material-extensions/select-country';
import {CountryService} from '../../../../services/country.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CityInputComponent} from '../../ux/inputs/city-input/city-input.component';
import {SchoolService} from '../../../../services/school.service';
import {finalize, first, take} from 'rxjs/operators';
import {ProcessService} from '../../../../services/user-services/process.service';
import {UserService} from '../../../../services/user-services/user.service';
import {AlertService} from '../../../../services/alert.service';
import {ProcessSharedService} from '../../../../services/process-shared.service';
import {BtnStickyBotComponent} from '../../ux/buttons/btn-sticky-bot/btn-sticky-bot.component';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {DatePipe, NgClass, NgFor, NgIf} from '@angular/common';
import {MatExpansionModule} from '@angular/material/expansion';
import {IconComponent} from '../../icons-svgs/icons-svgs.component';
import {AccommodationRoomCardComponent} from '../../accommodation-specific/accommodation-room-card/accommodation-room-card.component';

@Component({
  selector: 'app-user-informations',
  templateUrl: './user-informations.component.html',
  styleUrls: ['./user-informations.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, MatExpansionModule, NgIf, MatFormFieldModule, NgClass, MatInputModule, NgxIntlTelInputModule, BirthdateDividedComponent, CityInputComponent, MatSelectCountryModule, MatSelectModule, NgFor, MatOptionModule, BtnStickyBotComponent, DatePipe, TranslateModule, IconComponent, AccommodationRoomCardComponent]
})
export class UserInformationsComponent implements OnInit {
//------------------- INPUTS
  @Input() public user:any = null;
  @Input() public btnConfig = {name: '', btnIcon: ''};

//------------------------------
//------------------- FORMULAIRE
  public form: FormRecord = new FormRecord<FormControl<string|null>>({});
  public isFormSubmit = false;
  public isBirthdayCorrect = true;
  public isArrivalDateCorrect = true;
  public predefinedCountries: Country[] = [];
  public nationalityField;
  public displayUnit = false;
  public isLoading =false;
  public errors = {'firstname': null,'lastname': null,'birthplace': null};
  public isManualInput = false;
  //-------------------------------
  //------------------- OBJETS
  public schools: any[] = [];
  public faculties:any[] = [];
  public selectedSchool:any;
  public startingCities: [{id,name}];
  public formations: any[] = [];
  public favoritesAccom: any[];
  public roomsDetails: any[] = [];
  public bError;

  //-------------------------------
  //------------------- XXX
  public locale: string;
  public loggedinUser;
  public isLoadingFav: boolean = false;

  constructor(
    private countryService: CountryService,
    private translate: TranslateService,
    private schoolService: SchoolService,
    private processService: ProcessService,
    private userService: UserService,
    private alertService: AlertService,
    private processSharedService: ProcessSharedService,
  ) { }

  ngOnInit(): void {
    this.isLoadingFav = true;
    this.loggedinUser = this.userService.getInfos();
    // @TODO : check si ça récupère les logements du user voulu ou de l'admin, j'ai un doute (Gwen - 18.03.24 - ticket 2901 )
    this.processSharedService.getAccommodationFavorite(this.user ? this.user.id : null).subscribe(async (data: any) => {
      this.favoritesAccom = data;
      this.processSharedService.getRooms(data).subscribe(async (response: any) => {
          this.roomsDetails = response;
          this.isLoadingFav = false;
        }
      );
    });

    // PANEL 1
   this.form.addControl('firstname', new FormControl<string|null>(this.user.firstname && this.user.firstname.trim().length > 0 ? this.user.firstname : null,));
   this.form.addControl('lastname', new FormControl<string|null>(this.user.lastname && this.user.lastname.trim().length > 0 ? this.user.lastname : null));
   this.form.addControl('gender', new FormControl<string|null>(this.user.gender));
   this.form.addControl('birthdate', new FormControl<string|null>(this.user.birthdate));
   this.form.addControl('birthplace', new FormControl<string|null>(this.user.birthplace));
   this.form.addControl('birthCountry', new FormControl<string|null>(this.user.birthCountry));
   this.form.addControl('nationality', new FormControl<string|null>(this.nationalityField));
    if (this.user.nationality) {
      this.nationalityField = this.user.nationality;
      const currentNationality = this.countryService.getCountry(this.nationalityField);
      if (currentNationality && currentNationality.name) {
        currentNationality.name = this.translate.instant(currentNationality.name);
        this.form.controls.nationality.setValue(currentNationality);
      }
    }

    // PANEL 2
    this.form.addControl('email', new FormControl<string|null>(this.user.email));
    this.form.addControl('phone', new FormControl<string|null>(this.user.phone && this.user.phone.trim().length > 0 ? this.user.phone : null));
    this.form.addControl('studentPhone', new FormControl<string|null>(this.user.studentPhone));

    // PANEL 3
    this.selectedSchool = this.user.school;
    this.schoolService.getAll().pipe(take(1)).subscribe((data: any) => {
      this.schools = data;
      this.schools = this.schools.sort((a, b) => a.name > b.name ? 1 : a.name === b.name ? 0 : -1);
    })
    this.schoolService.getStartingElements().subscribe((data) => {
        this.startingCities = data.cities;
      }
    );
    this.form.addControl('school', new FormControl<string|null>(this.user.school_id ? this.user.school_id.toString() : null));
    this.form.addControl('faculty_id', new FormControl<number|null>(this.user.faculty_id));
    this.form.addControl('studyPlace', new FormControl<string|null>(this.user.city_id ? this.user.city_id.toString() : null));
    this.form.addControl('situation', new FormControl<string|null>(this.user.situation));
    this.form.addControl('formation_id', new FormControl<number|null>(this.user.formation_id));
    this.form.addControl('stayDuration', new FormControl<number|null>(this.user.stayDuration));
    this.form.addControl('arrivalDate', new FormControl<string|null>(this.user.arrivalDate));

    //@TODO : check faculties
    this.form.get('school').valueChanges.subscribe( data => {
      this.selectedSchool = this.schools.find(s => s.id == parseInt(data));
      if (this.selectedSchool.faculties && this.selectedSchool.faculties.length > 0) {
        this.faculties = this.selectedSchool.faculties;
      }
    });
    this.processSharedService.getFormations().subscribe(async (data: any) => {
      this.formations = data.data;
    });
    // PANEL 4
    this.form.addControl('homeAddress', new FormControl<string|null>(this.user.homeAddress));
    this.form.addControl('homeAdditionalAddress', new FormControl<string|null>(this.user.homeAdditionalAddress));
    this.form.addControl('postalCode', new FormControl<string|null>(this.user.postalCode));
    this.form.addControl('homeCity_name', new FormControl<string|null>(this.user.homeCity_Info?.name));
    this.form.addControl('homeCity_id', new FormControl<string|null>(this.user.homeCity_id));
    this.form.addControl('country', new FormControl<string|null>(this.user.homeCountry_Info?.country));
    if (this.user.country) {
      const currentCountry = this.countryService.getCountry(this.user.country);
      currentCountry.name = this.translate.instant(currentCountry.name);
      this.form.controls.country.setValue(currentCountry);
    }


    // PANEL 5
    this.form.addControl('address', new FormControl<string|null>(this.user.address));
    this.form.addControl('studentZipCode', new FormControl<string|null>(this.user.studentZipCode));
    this.form.addControl('studentCountry', new FormControl<string|null>('FR'));
    this.form.addControl('studentCity', new FormControl<string|null>(this.user.studentCity));

   //- Set datas
   this.getCountries();

   // Ajoute des validateurs si user pas admin
   if (!this.loggedinUser.isGhost) {
     this.form.get('gender').addValidators(Validators.required);
     this.form.get('phone').addValidators(Validators.required);
     this.form.get('birthdate').addValidators(Validators.required);
     this.form.get('nationality').addValidators(Validators.required);
     this.form.get('postalCode').addValidators(Validators.required);
     this.form.get('homeAddress').addValidators(Validators.required);
     if (this.faculties && this.faculties.length > 0) {
       this.form.get('faculty_id').addValidators(Validators.required);
     }
   }
  }


  public propertyTrackBy(index: number, property) {
    return property.id;
  }

//------------------- VIEWCHILD - loaded after ngOnInit()
  @ViewChild('birthdayInputs') private birthdayInputs: BirthdateDividedComponent;
  @ViewChild('ArrivalComponent') private arrivalDateInputs: BirthdateDividedComponent;
  @ViewChild('CityInputComponent') private CityInputComponent: CityInputComponent;
  @ViewChild('FrenchCityInputComponent') private FrenchCityInputComponent: CityInputComponent;

//-------------------------------------------------------

  public changeDisplayUnit(): void {
    this.displayUnit = !this.displayUnit;
  }

  /**
   *
   * @private
   */
  private getCountries(){
    this.predefinedCountries = [];
    this.predefinedCountries = this.countryService.getCountries();
    this.translate.get('COUNTRIES').subscribe((value) => {
      this.predefinedCountries.forEach(element => {
        const code = element.alpha2Code ;
        element.name = this.translate.instant('COUNTRIES.' + code);
      });
    });
  }


  /*
   - Appelée à chaque changement de date de naissance.
   - Vérifie que la date de naissance est correcte.
   */
  private checkDate(type: string, event: any , fc: any) {
    if (event.yearControl && event.monthControl && event.dayControl) {
      const dateCheck = new Date(event.yearControl, event.monthControl -1, event.dayControl);
      if (dateCheck.getFullYear() != event.yearControl || (dateCheck.getMonth() + 1) != event.monthControl || dateCheck.getDate() != event.dayControl) {
        if (type === 'birthdate') this.isBirthdayCorrect = false;
        else this.isArrivalDateCorrect = false;
      } else {
        if (type === 'birthdate') this.isBirthdayCorrect = true;
        else this.isArrivalDateCorrect = true;
        fc.setValue(dateCheck.getFullYear() + '-' + (dateCheck.getMonth() + 1) + '-' +  dateCheck.getDate());
      }
    }
  }

  onCountrySelected($event: any, type: string) {
    if (type == 'nationality') {
      if ($event) {
        this.nationalityField = $event.alpha2Code;
      }
      this.form.patchValue({nationality: $event});
    }
    if (type == 'country') {
      this.form.patchValue({country: $event});
    }
  }

  setInfos(event: any, type: string) {
    switch (type) {
      case 'city': {
        if (event.formatted_address) {
          let replace = event.formatted_address.replace('-', ',')
          let split = replace.split(', ');
          if(split.length > 1){
            this.form.controls.birthCountry.setValue(split[split.length - 1]);
            split.splice(split.length - 1, 1);
          }
          this.form.controls.birthplace.setValue( split.join(', ').replace(/[0-9]/g, '').replace(/\s/g, ""));
          this.form.controls.birthplace.setErrors(null);
        }
        else if(event && this.isManualInput === true) {
          if(this.bError == 'list'){
            this.form.controls.birthplace.setValue(event);
            this.form.controls.birthplace.setErrors(null);
            this.errors.birthplace = null;
            this.bError = null;
          }
        }
        else {
          this.errors.birthplace = this.translate.instant('COMMON.NOT_CLICK_IN_LIST');
          this.bError = 'list';
          this.form.controls.birthplace.setErrors({'incorrect': true});

        }
        break;
      }
      case 'birthdate': {
        this.checkDate('birthdate', event, this.form.controls.birthdate);
        break;
      }
      case 'arrivalDate': {
        this.checkDate('arrivalDate', event, this.form.controls.arrivalDate);
        break;
      }
      case 'homeCity': {
        if (event.id || event.name) {
          this.form.controls.homeCity_id.setValue(event.id);
          this.form.controls.homeCity_name.setValue(event.name);
        }
        break;
      }
      case 'studyCity': {
        if (event.name){
          this.form.controls.studentCity.setValue(event.name);
        }

        break;
      }
      case 'add' : {
        break;
      }
    }
  }

  hasBeenClick(event: any) {
    this.form.controls.birthplace.setErrors(null);
    this.errors.birthplace = null;
    this.bError = null;
  }







  /*
   - Appelée à chaque fois que le form est envoyé.
   - Vérifie que le form est ok.
   - Update les données de l'utilisateur.
   */
  public submit() {
    //- Passe le birthdate input en erreur si besoin
    this.birthdayInputs.dayControl.markAsTouched();
    this.birthdayInputs.monthControl.markAsTouched();
    this.birthdayInputs.yearControl.markAsTouched();
    //- update datas
    if (this.bError !== null) {
      this.form.controls.birthplace.setErrors({'incorrect': true});
    }
    this.isFormSubmit = true;
    this.isLoading = true;
    if (this.form.valid &&
      (!this.form.value.birthdate || (this.form.value.birthdate && this.isBirthdayCorrect)) &&
      (!this.form.value.arrivalDate || (this.form.value.arrivalDate && this.isArrivalDateCorrect))) {
      const fullHomeAddress = this.form.value.homeAddress  + ', ' + this.form.value.postalCode + ' ' + (this.form.value.homeCity_name ? this.form.value.homeCity_name + ' ' : '') + (this.form.value.country ? this.form.value.country.alpha2Code : '')  ;
      this.userService.update({
        id: this.user.id,
        firstname: this.form.value.firstname,
        lastname: this.form.value.lastname,
        gender: this.form.value.gender,
        birthdate: this.form.value.birthdate,
        birthplace: this.form.value.birthplace,
        birthCountry: this.form.value.birthCountry,
        nationality: this.form.value.nationality ? this.form.value.nationality.alpha2Code : null,
        email: this.form.value.email,
        phone: this.form.value.phone,
        studentPhone: this.form.value.studentPhone,
        school_id: this.form.value.school,
        city_id: this.form.value.studyPlace,
        faculty_id: this.form.value.faculty_id,
        situation: this.form.value.situation,
        formation_id: this.form.value.formation_id,
        stayDuration: this.form.value.stayDuration,
        arrivalDate: this.form.value.arrivalDate,
        homeAddress: this.form.value.homeAddress,
        homeAdditionalAddress: this.form.value.homeAdditionalAddress,
        postalCode: this.form.value.postalCode,
        homeCity_id: this.form.value.homeCity_id,
        country: this.form.value.country ? this.form.value.country.alpha2Code : null,
        address: this.form.value.address,
        fullHomeAddress: fullHomeAddress,
        studentZipCode: this.form.value.studentZipCode,
        studentCountry: this.form.value.studentCountry,
        studentCity: this.form.value.studentCity,
      }).pipe(first(),
        finalize(()=> {
          this.isLoading = false;
        })).subscribe(() => {
        this.alertService.openSnackBar('L\'utilisateur a bien été modifié.', 'snack-success');
        },
        (error) => {
          this.alertService.openSnackBar(error, 'snack-error');
        }
      );
    }
    else{
      this.isLoading = false;
      this.alertService.openSnackBar('Erreurs sur le formulaire', 'snack-error');

    }

  }

  public checkLatin(field,e){
    const  regex = new RegExp("^[A-zÀ-ÿ0-9- ']+$");
    if (regex.test(e.target.value)) {
      if(this.bError == 'latin'){
        this.errors[field] = null;
        this.form.controls[field].setErrors(null);
        this.bError = null;
      }
    }
    else{
      if(this.bError != 'latin') {
        this.errors[field] = this.translate.instant('COMMON.ONLY_LATIN_ERROR');
        this.bError = 'latin';
      }
      this.form.controls[field].setErrors({'incorrect': true});

    }
  }

  changeManualInput(){
    this.isManualInput = !this.isManualInput;
    this.form.controls.birthplace.setErrors(null);
    this.errors.birthplace = null;
  }




}
